import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const AuthModal = ({ isOpen, onClose }) => {
  const [tab, setTab] = useState('login'); // 'login' or 'signup'
  
  // State for forms
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [skipperName, setSkipperName] = useState('');
  const [boatName, setBoatName] = useState('');
  
  // UI States
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  if (!isOpen) return null;

  const showMessage = (msg, error = false) => {
    setMessage(msg);
    setIsError(error);
  };

  const clearForm = () => {
    setEmail(''); setPassword(''); setSkipperName(''); setBoatName(''); setMessage('');
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    showMessage('');
    
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) {
      showMessage(error.message, true);
    } else {
      showMessage("Logged in successfully! Welcome aboard ⛵", false);
      setTimeout(() => { onClose(); clearForm(); }, 1500);
    }
    setLoading(false);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    showMessage('');

    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          skipper_name: skipperName,
          boat_name: boatName,
        }
      }
    });

    if (error) {
      showMessage(error.message, true);
    } else {
      showMessage("Registration complete! Please check your email closely to confirm your account.", false);
      setTimeout(() => { onClose(); clearForm(); }, 3500);
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={() => { onClose(); clearForm(); }}>&times;</button>
        
        <div className="tab-header">
          <button 
            className={tab === 'login' ? 'tab-btn active' : 'tab-btn'} 
            onClick={() => { setTab('login'); clearForm(); }}
          >Login</button>
          <button 
            className={tab === 'signup' ? 'tab-btn active' : 'tab-btn'} 
            onClick={() => { setTab('signup'); clearForm(); }}
          >Register Boat</button>
        </div>

        <div className="auth-body">
          {message && (
            <div style={{ padding: '10px', marginBottom: '15px', borderRadius: '4px', textAlign: 'center', backgroundColor: isError ? '#f8d7da' : '#d4edda', color: isError ? '#721c24' : '#155724', fontSize: '14px' }}>
              {message}
            </div>
          )}

          {tab === 'login' ? (
            <form className="auth-form" onSubmit={handleLogin}>
              <h3>Welcome Back</h3>
              <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} required />
              
              <div style={{ position: 'relative', marginBottom: '15px' }}>
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                  style={{ width: '100%', boxSizing: 'border-box', paddingRight: '40px', marginBottom: 0 }} 
                />
                <span 
                  onClick={() => setShowPassword(!showPassword)} 
                  title="Toggle Password Visibility"
                  style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '18px' }}
                >
                  {showPassword ? '🙈' : '👁️'}
                </span>
              </div>
              
              <button type="submit" className="confirm-button" disabled={loading}>
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </form>
          ) : (
            <form className="auth-form" onSubmit={handleSignup}>
              <h3>Entry Form</h3>
              <input type="text" placeholder="Skipper Name" value={skipperName} onChange={(e) => setSkipperName(e.target.value)} required />
              <input type="text" placeholder="Boat Name / Sail #" value={boatName} onChange={(e) => setBoatName(e.target.value)} required />
              <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} required />
              
              <div style={{ position: 'relative', marginBottom: '15px' }}>
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Create Password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                  style={{ width: '100%', boxSizing: 'border-box', paddingRight: '40px', marginBottom: 0 }} 
                />
                <span 
                  onClick={() => setShowPassword(!showPassword)} 
                  title="Toggle Password Visibility"
                  style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '18px' }}
                >
                  {showPassword ? '🙈' : '👁️'}
                </span>
              </div>
              
              <button type="submit" className="confirm-button" disabled={loading}>
                {loading ? "Registering..." : "Enter Regatta"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
